import { createAction, createReducer } from '../../util/redux';
import { mergeDeepRight } from 'ramda';

/*
 |--------------------------------------------------------------------------
 | Default state
 |--------------------------------------------------------------------------
 */

const defaultState = {};

/*
 |--------------------------------------------------------------------------
 | Actions - anything that changes the store
 |--------------------------------------------------------------------------
 */
const CLEAR_REGISTRATION = 'CLEAR_REGISTRATION';
const clearRegistration = createAction(CLEAR_REGISTRATION);
function clearRegistrationHandler() {
  return {};
}

const OVERWRITE_REGISTRATION = 'OVERWRITE_REGISTRATION';
const overwriteRegistration = createAction(OVERWRITE_REGISTRATION);
function overwriteRegistrationHandler(state, { payload }) {
  return payload;
}

const UPDATE_REGISTRATION = 'UPDATE_REGISTRATION';
const updateRegistration = createAction(UPDATE_REGISTRATION);
function updateRegistrationHandler(state, { payload }) {
  return mergeDeepRight(state, payload);
}

const UPDATE_REGISTRATION_EXPERIENCES = 'UPDATE_REGISTRATION_EXPERIENCES';
const updateRegistrationExperiences = createAction(UPDATE_REGISTRATION_EXPERIENCES);
function updateRegistrationExperiencesHandler(state, { payload }) {
  return {
    ...state,
    experiences: payload,
  };
}

const UPDATE_REGISTRATION_VALIDATIONS = 'UPDATE_REGISTRATION_VALIDATIONS';
const updateRegistrationValidations = createAction(UPDATE_REGISTRATION_VALIDATIONS);
function updateRegistrationValidationsHandler(state, { payload }) {
  return {
    ...state,
    experienceValidation: payload,
  };
}

const UPDATE_REGISTRATION_EXAMS = 'UPDATE_REGISTRATION_EXAMS';
const updateRegistrationExams = createAction(UPDATE_REGISTRATION_EXAMS);
function updateRegistrationExamsHandler(state, { payload }) {
  return {
    ...state,
    exams: payload,
  };
}

const UPDATE_REGISTRATION_TRAININGS = 'UPDATE_REGISTRATION_TRAININGS';
const updateRegistrationTrainings = createAction(UPDATE_REGISTRATION_TRAININGS);
function updateRegistrationTrainingsHandler(state, { payload }) {
  return {
    ...state,
    trainings: payload,
  };
}

const UPDATE_REGISTRATION_MEDIA = 'UPDATE_REGISTRATION_MEDIA';
const updateRegistrationMedia = createAction(UPDATE_REGISTRATION_MEDIA);
function updateRegistrationMediaHandler(state, { payload }) {
  return {
    ...state,
    media: payload,
  };
}

/*
 |--------------------------------------------------------------------------
 | Thunks - same as actions but returns a promise. Good for chaining
 |--------------------------------------------------------------------------
 */

/*
 |--------------------------------------------------------------------------
 | Reducer - maps the action to the action handler
 |--------------------------------------------------------------------------
 */

export const registrationReducer = createReducer(defaultState, {
  [CLEAR_REGISTRATION]: clearRegistrationHandler,
  [OVERWRITE_REGISTRATION]: overwriteRegistrationHandler,
  [UPDATE_REGISTRATION]: updateRegistrationHandler,
  [UPDATE_REGISTRATION_EXPERIENCES]: updateRegistrationExperiencesHandler,
  [UPDATE_REGISTRATION_VALIDATIONS]: updateRegistrationValidationsHandler,
  [UPDATE_REGISTRATION_EXAMS]: updateRegistrationExamsHandler,
  [UPDATE_REGISTRATION_TRAININGS]: updateRegistrationTrainingsHandler,
  [UPDATE_REGISTRATION_MEDIA]: updateRegistrationMediaHandler,
});

/*
 |--------------------------------------------------------------------------
 | Action Exports
 |--------------------------------------------------------------------------
 */
export default {
  clearRegistration,
  overwriteRegistration,
  updateRegistration,
  updateRegistrationExperiences,
  updateRegistrationValidations,
  updateRegistrationExams,
  updateRegistrationTrainings,
  updateRegistrationMedia,
};
